import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatTokenPrefix } from "@helpers/tokenPrefix";
import type { McpCliTokenRow } from "../mcpCliTokensViewConfig";
import styles from "../McpCliSettings.module.scss";

export const TokenPrefixCell = memo(
    ({ getValue }: CellContext<ViewTableFeatures, McpCliTokenRow, string>) => (
        <ViewTableCell>
            <code className={styles.inlineCode}>
                {formatTokenPrefix(getValue())}
            </code>
        </ViewTableCell>
    ),
);
